import API from '../../services/API';
import { setError, startSpinner, stopSpinner, showModal,hideAllModals } from '../common/actionCreators';
import { NAV_BAR_TYPES } from '../../constants/actionTypes/navBarActionTypes';
import { LEFT_NAV_TYPES } from '../../constants/actionTypes/leftNavTypes';
import { entityModalTypes, transferStatusTypes } from '../../constants/entity/modals/entityModalTypes';
import { ASSISTER_LIST_TYPES, ASSISTER_FILTERS_TYPES, ASSISTER_PAGINATION_TYPES,ASSISTER_FILTER_VALIDATION_TYPES } from '../../constants/actionTypes/entityActionTypes';
import { configs } from '../../constants/configs/configs';
import { SPINNER_MESSAGES_IDS } from '../../constants/common/miscellaneous';
let interval;
const { endpoints } = configs;

export const setAssisterTableData = list => ({
    type: ASSISTER_LIST_TYPES.SET_ASSISTER_LIST,
    list
});

export const setCurrentAssister = assister => ({
    type: ASSISTER_PAGINATION_TYPES.SET_CURRENT_ASSISTER,
    assister
});

export const initAssisterFilters = filtersValues => ({
    type:  ASSISTER_FILTERS_TYPES.INIT_ALL_FILTERS,
    filtersValues
});

export const setEntitySites = sites => ({
    type: ASSISTER_FILTERS_TYPES.SET_ENTITY_SITE,
    value : sites
});

export const setFilterValue = newFilterValue => ({
    type: ASSISTER_FILTERS_TYPES.SET_FILTER_VALUE,
    newFilterValue
});

export const setFilterFormState = filterValidationObj => ({
    type : ASSISTER_FILTER_VALIDATION_TYPES.SET_FILTER_FORM_STATE,
    filterValidationObj
});

export const setExportBtnState = btnState => ({
    type : ASSISTER_FILTER_VALIDATION_TYPES.SET_EXPORT_BTN_STATE,
    btnState
});

export const setReassignBtnState = btnState => ({
    type : ASSISTER_FILTER_VALIDATION_TYPES.SET_REASSIGN_BTN_STATE,
    btnState
});

export const resetFilterValues = filtersInitialValues => ({
    type: ASSISTER_FILTERS_TYPES.RESET_FILTER_VALUES,
    filtersInitialValues
});

export const setPaginationCount = count => ({
    type: ASSISTER_PAGINATION_TYPES.SET_COUNT,
    count 
});

export const setNavBarData = navBarData => ({
    type: NAV_BAR_TYPES.SET_NAV_BAR_DATA ,
    navBarData
});

export const setLeftNavParams= leftNavParams => ({
    type: LEFT_NAV_TYPES.SET_LEFT_NAV_PARAMS ,
    leftNavParams
});

export const setSearchAPIInPrgFlag= flag => ({
    type: ASSISTER_PAGINATION_TYPES.SET_API_IN_PRG_FLAG ,
    inProgressFlag : flag
});

/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const fetchAssisterData = url => async dispatch => {
    //set inProgress flag = true
    dispatch(setSearchAPIInPrgFlag(true)); 
    const data = await API.getData(url, dispatch, actions);
    //set inProgress flag = false 
    dispatch(setSearchAPIInPrgFlag(false));
    if (data && data.success) {                
        dispatch(setAssisterTableData(data.payload.assisterList));
        dispatch(setPaginationCount(data.payload.count));
    } else {
        dispatch(setAssisterTableData([]));
        dispatch(setPaginationCount(0));

    }
};

export const fetchAssisterDataForAdmin = url => async dispatch => {
    dispatch(setSearchAPIInPrgFlag(true)); 
    dispatch(actions.startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
    const data = await API.getData(url, dispatch, actions,false);    
    
    if (data && data.success) {        
    
        dispatch(setAssisterTableData(data.payload.assisterList));
        dispatch(setPaginationCount(data.payload.totalAssisterBySearh));
    } else {
        dispatch(setAssisterTableData([]));
        dispatch(setPaginationCount(0));
    }
    
    dispatch(actions.stopSpinner());
    dispatch(setSearchAPIInPrgFlag(false)); 
};

export const fetchNavBarData = url => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        dispatch(setNavBarData(data.menu));
    }
};

export const exportAssisterBob = url => async dispatch => {    
    await API.getData(url, dispatch, actions);
};

export const fetchLeftNavParams = url => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        dispatch(setLeftNavParams(data));
    }
};

export const getBOBTransferStatus = (url) => async dispatch => {
    const data =  await API.customGetData(url,dispatch,actions,{ 'cache-control':'no-cache', 'If-Modified-Since':'0' });  
    dispatch(hideAllModals());
    if(data.status === transferStatusTypes.NONE){
        clearInterval(interval);     
        return;
    }
    if(!(data.status === transferStatusTypes.IN_PROGRESS || transferStatusTypes.PENDING)){
        clearInterval(interval);       
    }
    let mType = getModalType(data.status);        
    dispatch(showModal({
        modalType: mType,
        modalData : data
    }));        
    
};

export const reassignBOBToCEC = (url,payload,intervalFrequecy) => async dispatch => {

    localStorage.removeItem('individuals');
    localStorage.removeItem('bobItems');
    localStorage.removeItem('bobItems_selectAll');
    localStorage.removeItem('targetCECName');
    window.traverssingToTransferPage = false;

    const shouldShowSpinner = true;
    const params = [ url, payload, undefined, shouldShowSpinner ];
    const data = await API.postData(params, dispatch, actions);        
    dispatch(hideAllModals());
    if(data && data.success){
        if(data.payload.status === transferStatusTypes.NONE){
            return;
        }

        if(data.payload.status === transferStatusTypes.IN_PROGRESS || data.payload.status === transferStatusTypes.PENDING){            
            interval = setInterval(() => {                
                dispatch(getBOBTransferStatus(endpoints.GET_TRNFR_STATUS));
            }, intervalFrequecy);            
        }else{            
            clearInterval(interval);            
        }

        let mType = getModalType(data.payload.status);
        
        dispatch(showModal({
            modalType: mType,
            modalData : data.payload
        }));        
    }else{                        
        dispatch(showModal({
            modalType: entityModalTypes.TRANSFER_ERROR_MODAL,
            modalData : data.payload
        }));
    }
};

const getModalType = ( status ) =>{
    switch(status){
        case transferStatusTypes.IN_PROGRESS:
        case transferStatusTypes.PENDING :   {
            return entityModalTypes.TRANSFER_IN_PROGRESS_MODAL;
        }
        case transferStatusTypes.SUCCESS :{
            return entityModalTypes.TRANSFER_SUCCESS_MODAL;
        }
        case transferStatusTypes.PARTIAL_SUCCESS :{
            return entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL;
        }        
        case transferStatusTypes.FAILED  : {
            return entityModalTypes.TRANSFER_FAILURE_MODAL;
        }
        case transferStatusTypes.INCOMPLETE :{
            return entityModalTypes.TRANSFER_INCOMPLETE_MODAL;
        }
        case transferStatusTypes.VALIDATION_ERROR :{
            return entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL;
        }
    }
};

export const fetchEntitySiteList = url => async dispatch => { 
    const data = await API.getData(url,dispatch,actions);
    if(data && data.success){        
        dispatch(setEntitySites(data.payload.sites));
    }
};
